import React from 'react';
import { ArrowRight, Shield } from 'lucide-react';
import { siteConfig } from '../../data/mock';

export const Hero = () => {
  const handleScroll = (e, targetId) => {
    e.preventDefault();
    const element = document.querySelector(targetId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center bg-black pt-20">
      {/* Subtle grid overlay */}
      <div 
        className="absolute inset-0 opacity-[0.03]"
        style={{
          backgroundImage: `
            linear-gradient(to right, #fff 1px, transparent 1px),
            linear-gradient(to bottom, #fff 1px, transparent 1px)
          `,
          backgroundSize: '60px 60px'
        }}
      />
      
      <div className="relative max-w-7xl mx-auto px-6 lg:px-12 py-24 lg:py-32">
        <div className="max-w-3xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/5 border border-white/10 mb-8">
            <Shield size={16} className="text-[#C9A962]" />
            <span className="text-white/80 text-sm font-medium">Privacy-First Documentation</span>
          </div>

          {/* Main Heading */}
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-semibold text-white leading-[1.1] tracking-tight mb-6">
            {siteConfig.name}
          </h1>

          {/* Tagline */}
          <p className="text-xl md:text-2xl text-white/60 font-normal leading-relaxed mb-10 max-w-2xl">
            {siteConfig.tagline}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="#pricing"
              onClick={(e) => handleScroll(e, '#pricing')}
              className="inline-flex items-center justify-between gap-3 px-8 py-4 bg-[#C9A962] text-black font-medium text-base transition-all duration-400 hover:bg-[#C9A962]/10 hover:text-[#C9A962] min-w-[200px]"
            >
              <span>Get Started</span>
              <ArrowRight size={18} />
            </a>
            <a
              href="#how-it-works"
              onClick={(e) => handleScroll(e, '#how-it-works')}
              className="inline-flex items-center justify-between gap-3 px-8 py-4 bg-white/10 text-white font-medium text-base transition-all duration-400 hover:bg-white hover:text-black min-w-[200px]"
            >
              <span>Learn More</span>
              <ArrowRight size={18} />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
